var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00016 11.5475C7.40266 11.5475 6.09766 10.25 6.09766 8.645C6.09766 7.04 7.40266 5.75 9.00016 5.75C10.5977 5.75 11.9027 7.0475 11.9027 8.6525C11.9027 10.2575 10.5977 11.5475 9.00016 11.5475ZM9.00016 6.875C8.02516 6.875 7.22266 7.67 7.22266 8.6525C7.22266 9.635 8.01766 10.43 9.00016 10.43C9.98266 10.43 10.7777 9.635 10.7777 8.6525C10.7777 7.67 9.97516 6.875 9.00016 6.875Z",
    fill: "#B0BECF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00123 17.9919C7.89123 17.9919 6.77373 17.5719 5.90373 16.7394C3.69123 14.6094 1.24623 11.2119 2.16873 7.16937C3.00123 3.50188 6.20373 1.85938 9.00123 1.85938C9.00123 1.85938 9.00123 1.85938 9.00873 1.85938C11.8062 1.85938 15.0087 3.50188 15.8412 7.17688C16.7562 11.2194 14.3112 14.6094 12.0987 16.7394C11.2287 17.5719 10.1112 17.9919 9.00123 17.9919ZM9.00123 2.98438C6.81873 2.98438 4.01373 4.14687 3.27123 7.41687C2.46123 10.9494 4.68123 13.9944 6.69123 15.9219C7.98873 17.1744 10.0212 17.1744 11.3187 15.9219C13.3212 13.9944 15.5412 10.9494 14.7462 7.41687C13.9962 4.14687 11.1837 2.98438 9.00123 2.98438Z",
    fill: "#B0BECF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.428461759e379bb3fb832d50ae65c9b6.svg";
export { ForwardRef as ReactComponent };